




































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Global } from '@/store';
import { formatScheduleEndDate } from '@/modules/ScheduleUtils';
import ScheduleExpirationBadge from '@/components/ScheduleExpirationBadge.vue';

@Component({ components: { ScheduleExpirationBadge } })
class ExpiringSchedulesDialog extends Vue {
  @Global.State('lang') lang;

  @Prop({ type: Array, default: () => [] }) schedules;

  get dir() {
    return this.lang === 'en' ? 'ltr' : 'rtl';
  }

  /* Header and value of every column have to line up on the same edge. */
  get text_align_class() {
    return this.lang === 'en' ? 'text-xs-left' : 'text-xs-right';
  }

  formatEndDate(end_date) {
    return formatScheduleEndDate(end_date);
  }

  goToSchedules() {
    this.$emit('close');
    if (this.$route.path !== '/schedules') this.$router.push('/schedules');
  }
}

export default ExpiringSchedulesDialog;
